class HeaderReveal {
  constructor(element) {
    this.element = element;
    this.mount();
  }

  mount() {
    this.isDesktop = window.matchMedia('(min-width: 1024px)').matches;
    this.isLandscape = window.matchMedia('(orientation: landscape)').matches;

    if (this.isDesktop) {
      this.bindEvents();
    } else if (this.isLandscape) {
      this.bindEvents();
      this.$tocList = this.element.querySelector('.toc__list');
    }
  }

  bindEvents() {
    this.previousScrollPos = window.pageYOffset;
    this.headerHeight = this.element.offsetHeight;
    window.addEventListener('scroll', this.onScroll.bind(this), {passive: true});
  }

  onScroll() {
    const tocIsOpen = this.$tocList?.classList.contains('is-open');
    const currentScrollPos = window.pageYOffset;
    if ((this.previousScrollPos > currentScrollPos) || tocIsOpen) {
      this.element.style.top = '0';
    } else {
      this.element.style.top = `-${this.headerHeight}px`;
    }
    this.previousScrollPos = currentScrollPos;
  }
}

export default HeaderReveal;
